import { Link } from "react-router-dom";
import { Radio } from "lucide-react";

export function MarketingFooter() {
  return (
    <footer className="hairline-t mt-24 md:mt-32 pb-safe">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 lg:px-12 py-10 md:py-14">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <Link to="/" className="flex items-center gap-2 font-display font-semibold tracking-tight">
            <Radio className="h-[18px] w-[18px] text-primary" />
            EchoCRM
          </Link>
          <nav className="flex flex-wrap gap-x-6 gap-y-3 text-[13px] text-muted-foreground">
            <Link to="/features" className="hover:text-foreground">Features</Link>
            <Link to="/pricing" className="hover:text-foreground">Pricing</Link>
            <Link to="/about" className="hover:text-foreground">About</Link>
            <Link to="/real-estate-crm" className="hover:text-foreground">Real Estate CRM</Link>
            <Link to="/ai-crm" className="hover:text-foreground">AI CRM</Link>
            <Link to="/crm-for-small-business" className="hover:text-foreground">Small Business CRM</Link>
            <Link to="/terms" className="hover:text-foreground">Terms</Link>
            <Link to="/privacy" className="hover:text-foreground">Privacy</Link>
            <a href="mailto:support@echocrm.app" className="hover:text-foreground">Support</a>
          </nav>
        </div>
        <p className="mt-8 text-[12px] text-muted-foreground">© {new Date().getFullYear()} EchoCRM. Built for sales teams that move fast.</p>
        <p className="mt-2 text-[11px] text-muted-foreground/80 max-w-3xl">
          EchoCRM's use of information received from Google APIs will adhere to the{" "}
          <a
            href="https://developers.google.com/terms/api-services-user-data-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-foreground"
          >
            Google API Services User Data Policy
          </a>
          , including the Limited Use requirements.
        </p>
      </div>
    </footer>
  );
}